import { Component, OnInit, Injector, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';
import { CimsService } from 'src/modules/base/services/cims.service';
@Component({
    selector: 'kx-pop-up-over-grid-with-controls',
    templateUrl: './pop-up-over-grid-with-controls.component.html',
    styleUrls: ['./pop-up-over-grid-with-controls.component.scss'],
    standalone: false
})
export class PopUpOverGridWithControlsComponent extends MainComponent implements OnInit {
  @ViewChild('iframeElement', { static: false }) iframeElement!: ElementRef;
  public currentData: any;
  multiFile:any={};
  public resource: any;
  public gridContainer: any;
  public type: string;
  public rowData: any;
  showHistory: boolean = false;
  public mainBody: any;
  public editableResource: string;
  public _currentData: any = {};
  public showDirect: boolean = false;
  public showINDirect: boolean = false;
  public gridData: any = {};
  public documentIds: any = [];
  public documentId: any;
  imageUrl: string = "";
  items: Array<any> = [];
  isChecked: number = 0;
  index: number = 0;
  blobResp: any;
  theHtmlString:any;
  doc_Flag: boolean = false;
  textFile: any = {};
  configForDocument: any = {
    showTypeDropdown: false
  }
  folderName: any[] = [];
  document_type: 'orgImage';
  fileData: any[] = [];
  imageSrc: any[] = [];
  decodedText: string;
  tmc: any;
  textFlag: boolean = false;
  sanitizerBlob: any;
  pdfDocument: any = {};
  itemData: any;
  public page_no: number = 0;
  config: any;
  configList: any;
  mappingKeysFound:boolean=false;
  constructor(
    public Injector: Injector,
    private router: Router,
    private route: ActivatedRoute,
    public loader: LoaderService,
    private cdRef: ChangeDetectorRef,
    public smartModalService: SmartModalService,
    private dialogConfig: DialogConfig,
    private cimsService : CimsService
  ) {
    super(Injector, route)
  }

  ngOnInit() {
    this['data'] = this.dialogConfig;
    if (this.dialogConfig.popupConfig && typeof this.dialogConfig.popupConfig == 'object') {
      this['data'].resourcedef = { ...this.dialogConfig.popupConfig.action_config, ...this.dialogConfig.popupConfig.action_config.datasource }
      this['data'].currentData = this.dialogConfig.data;
      this['data'].type = this.dialogConfig.popupConfig.action_config.type;
      delete this['data'].data
    }
    if(this['data'] && this['data'].type == 'htmlViewer'){
      this.theHtmlString = this['data'].html ? this['data'].html : (this['data'].currentData && this['data'].currentData.item && this['data'].currentData.item.terms_and_conditions ? this['data'].currentData.item.terms_and_conditions : '');
      setTimeout(() => {
          this.disableIframeClickEvents();
      }, 500);
    }
    if(this['data'].type == 'view_documents'){
      if(this['data'] && this['data'].currentData.hasOwnProperty(this['data'].field.key) && this['data'].currentData[this['data'].field.key]){
       // this.multiFile = this['data'].currentData[this['data'].field.key];
       this['data']['data'] = this['data'].currentData;
        this.itemData = this['data'].currentData;
       // this.getImageData(this.multiFile[0].documentId);
       //return false;
      }else{
        this.alerts.error("No Documents found.");
      }
    }
    //image, doc and text view on popup
    if (this.dialogConfig.data) {
      this.itemData = this.dialogConfig.data;
      if (this.itemData.fieldAction == "text") {
        if (this.itemData.item.terms_conditions != undefined && this.itemData.item.terms_conditions != '')
          this.tmc = this.itemData.item.terms_conditions;
        else
          this.textFlag = true;
      }
      else if (this.checkMappingKeys() || this.itemData.manufacturerDocuments || this.itemData.documents || this.itemData.payer_document || this.itemData.refund_documents ||  this.itemData.discount_document || this.itemData.bill_documents || this.itemData.hie_supporting_info || this.itemData.counselling_document || this['data'].type == 'view_documents') {
        if (this.itemData.payer_document && this.itemData.payer_document.length) {
          this.itemData.payer_document.forEach(subelement => {
            this.documentId = subelement.document_id;
            this.folderName = subelement.folder_name;
            this.documentIds.push(this.documentId);

          });

          if (this.documentIds != undefined) {
            this.documentId = this.documentIds[0];
            if (this.documentId)
              this.getImageData(this.documentId, this.folderName);
          }
        }
        if (this.mappingKeysFound) {
            const mappingKeys = this["data"]?.config?.mapping_keys;
            const rootName = mappingKeys?.rootName;
            const childName = mappingKeys?.childName;
            const rootData = this?.itemData?.[rootName];

            if (rootName && childName && Array.isArray(rootData) && rootData.length > 0 ) {
              rootData.forEach(item => {
                this.documentId = item?.[childName];
                this.folderName = item?.folder_name;

                if (this.documentId) {
                  this.documentIds.push(this.documentId);
                }
              });

              if (Array.isArray(this.documentIds) && this.documentIds.length > 0) {
                this.documentId = this.documentIds[0];

                if (this.documentId) {
                  this.getImageData(this.documentId, this.folderName);
                }
              }
            }
          }
        else if (this.itemData.refund_documents && this.itemData.refund_documents.length) {
          this.itemData.refund_documents.forEach(subelement => {
            this.documentId = subelement.document_id;
            this.folderName = subelement.folder_name;
            this.documentIds.push(this.documentId);

          });

          if (this.documentIds != undefined) {
            this.documentId = this.documentIds[0];
            if (this.documentId)
              this.getImageData(this.documentId, this.folderName);
          }
        }
        // else if (this.itemData.documents && this.itemData.documents.length) {
        //   this.itemData.documents.forEach(subelement => {
        //     this.documentId = subelement.documentId;
        //     this.folderName = subelement.folder_name;
        //     this.documentIds.push(this.documentId);

        //   });

        //   if (this.documentIds != undefined) {
        //     this.documentId = this.documentIds[0];
        //     if (this.documentId)
        //       this.getImageData(this.documentId, this.folderName);
        //   }
        // }
        // else if (this.itemData.manufacturerDocuments && this.itemData.manufacturerDocuments.length) {
        //   this.itemData.manufacturerDocuments.forEach(subelement => {
        //     this.documentId = subelement.document;
        //     this.folderName = subelement.folder_name;
        //     this.documentIds.push(this.documentId);

        //   });

        //   if (this.documentIds != undefined) {
        //     this.documentId = this.documentIds[0];
        //     if (this.documentId)
        //       this.getImageData(this.documentId, this.folderName);
        //   }
        // }
         else if (this.itemData && this.itemData.discount_document) {
            this.documentId = this.itemData.discount_document.document_id;
            this.folderName = this.itemData.discount_document.folder_name;
            this.documentIds.push(this.documentId);

          if (this.documentIds != undefined) {
            this.documentId = this.documentIds[0];
            if (this.documentId)
              this.getImageData(this.documentId, this.folderName);
          }
        }
        else if (this.itemData.bill_documents && this.itemData.bill_documents.length) {
          this.itemData.bill_documents.forEach(subelement => {
            this.documentId = subelement.document_id;
            this.folderName = subelement.folder_name;
            this.documentIds.push(this.documentId);

          });
          
          if (this.documentIds != undefined) {
            this.documentId = this.documentIds[0];
            if (this.documentId)
              this.getImageData(this.documentId, this.folderName);
          }
        }
        else if (this.itemData.counselling_document && this.itemData.counselling_document.length) {
          this.itemData.counselling_document.forEach(subelement => {
            this.documentId = subelement.document_id;
            this.folderName = subelement.folder_name;
            this.documentIds.push(this.documentId);

          });
          
          if (this.documentIds != undefined) {
            this.documentId = this.documentIds[0];
            if (this.documentId)
              this.getImageData(this.documentId, this.folderName);
          }
        }
        if (this.itemData.documents && this.itemData.documents.length) {
          this.itemData.documents.forEach(subelement => {
            this.documentId = subelement.documentId;
            //this.folderName = subelement.folder_name;
            this.documentIds.push(this.documentId);

          });
          if (this.documentIds != undefined) {
            this.documentId = this.documentIds[0];
            if (this.documentId)
              this.getImageData(this.documentId);
          }
        }
        if (this.itemData.hie_supporting_info && this.itemData.hie_supporting_info.length) {
          this.itemData.hie_supporting_info.forEach(subelement => {
            this.documentId = subelement.document_id;
            //this.folderName = subelement.folder_name;
            this.documentIds.push(this.documentId);

          });
          if (this.documentIds != undefined) {
            const index = this.documentIds.findIndex(
              (x) => x != undefined && x != ""
            );
            this.documentId = this.documentIds[index];
            if (this.documentId)
              this.getImageData(this.documentId);
          }
        }
        else if (this.itemData && this.itemData.payer_document && !this.itemData.payer_document.length) {
          this.doc_Flag = true;
        }
      }

      else {
        this.doc_Flag = true;
      }
    }
    else {
      if (this['data'].fieldAction == "text") {
        if (this['data'].item.terms_conditions != undefined && this['data'].item.terms_conditions != '')
          this.tmc = this['data'].item.terms_conditions;
        else
          this.textFlag = true;
      }
    }

    this.configList = {
      "viewAll": true,
      "customButtonsAllowed": this.dialogConfig['resourcedef'] != undefined && this.dialogConfig['resourcedef'].popup != undefined && this.dialogConfig['resourcedef'].popup.customButtonsAllowed != undefined && this.dialogConfig['resourcedef'].popup.customButtonsAllowed == false ? false : true,
      "hideSearchBox": this.dialogConfig['resourcedef'] != undefined && this.dialogConfig['resourcedef'].popup != undefined && this.dialogConfig['resourcedef'].popup.hideSearchBox != undefined && this.dialogConfig['resourcedef'].popup.hideSearchBox == true ? true : false,
      "hideResult": false,
      "allowPagination": this.dialogConfig['resourcedef'] != undefined && this.dialogConfig['resourcedef'].popup != undefined && this.dialogConfig['resourcedef'].popup.allowPagination != undefined && this.dialogConfig['resourcedef'].popup.allowPagination == false ? false : true,
      "disableCapability" : this.router.url.includes("emrView") ? true : false,
    }
    if (this.dialogConfig.popupConfig && typeof this.dialogConfig.popupConfig == 'object' && this.dialogConfig.popupConfig.showBanner != undefined && this.dialogConfig.popupConfig.showBanner) {
      this.configList['showBanner'] = this.dialogConfig.popupConfig.showBanner;
    }
    this.editableResource = this['data'].resource;
    this.resource = this['data'].resourcedef;
    this.rowData = this['data'].row_data;
    this.currentData = this['data'].currentData;
    this.type = this['data'].type;
    this.mainBody = this['data'].mainBody; //for CardData
    if(this['data'] && this['data'].resourcedef && this['data'].resourcedef.list && this['data'].resourcedef.list.filter){
      this._currentData.currentFilterListFormFields = {
        blocks : this['data'].resourcedef?this['data'].resourcedef:{}
      };
    }else{
      this._currentData.currentFilterListFormFields = null;
    }
   
    this.config = {
      "submitButton": true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": this.resource && this.resource.popup && this.resource.popup.hasOwnProperty('delegate') ? this.resource.popup.delegate : true,
      "cancelRoute": ''
    }
    //this.gridData = {};
    if (this.type == 'table') {
      if (this.resource.list == undefined) {
        this.baseService.getResourceDef(this.resource.resource, (resouceDef) => {
          if (resouceDef) {
            this.resource['list'] = resouceDef.list;
            this.resource['list'].fields = this.rolePermissionService.getAllowedContextMenu(this.resource['list'].fields, resouceDef.capability, resouceDef.resource);
            if (resouceDef.list.APIresource && resouceDef.list.APIresource.datasource)
              this.resource = { ...this.resource, ...resouceDef.list.APIresource.datasource }
            this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData);
          }
        });
      } else {
        if (this.resource.capability && this.resource.capability.length && this.resource.list && this.resource.list.fields) {
          this.resource.list.fields = this.rolePermissionService.getAllowedContextMenu(this.resource.list.fields, this.resource.capability, this.resource.resource);
        }
        this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData);
      }
    }
    if (this.resource != undefined && this.resource.popup != undefined && this.resource.popup.form != undefined && typeof this.resource.popup.form == 'string') {
      this.showDirect = false;
      this.showINDirect = true;
      this.getResource(this.resource.popup.form);
    }
    if (this.resource != undefined && this.resource.popup != undefined && this.resource.popup.form != undefined && typeof this.resource.popup.form != 'string') {
      this.showDirect = true;
      this.showINDirect = false;
    }

  }
  getResource(resource) {
    this.baseService.getResourceDef(resource, (response) => {
      if (response) {
        this.getFormField(response);
      }
    });
  }
  checkMappingKeys(){
       const rootName = this["data"]?.config?.mapping_keys?.rootName;
        if (!rootName) {
        return false;
        }
        this.mappingKeysFound = true
        const rootData = this?.itemData?.[rootName];

        return Array.isArray(rootData) && rootData.length > 0;
  }
  disableIframeClickEvents() {
    const iframe = this.iframeElement.nativeElement;
    const doc = iframe.contentDocument || iframe.contentWindow?.document;

    if (doc && doc.body && doc.body.style) {
      // Disable pointer events inside the iframe
      doc.body.style.pointerEvents = 'none';
    }
  }
  ngAfterViewInit() {
    if (!this.cdRef['destroyed']) {
      this.cdRef.detectChanges();
    }
  }
  getFormField(resouceDef) {
    this.baseService.getReferredField(resouceDef.form, (response) => {
      console.log("Response is as [per info] ", response);
      this._currentData.currentFormFields = {};
      this._currentData.currentFormFields.blocks = response;
      // console.log("Form Fields ", this._currentData.currentFormFields);
    });
  }
  buttonAction(event) {
    if (event.actionType != undefined && event.actionType.action != undefined && event.actionType.action == 'refresh') {
      // this.bindGrid(this.gridData);
      this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData);
    } else if(event.actionType != undefined && event.actionType.action != undefined && event.actionType.action == 'print'){
      event.actionType.file_data.args = this.baseService.buildDyanamicStr(event.actionType.file_data.args, {data: event.data})
      let params = event.actionType;
      let printInfo = event.actionType.file_data;
      this.bindGridWithPrint(params, printInfo);
    } else if (event.actionType != undefined && event.actionType.action != undefined && event.actionType.action == 'custom') {
      
      if (event.actionType.required_rowData) {
        sessionStorage.setItem('currentData', JSON.stringify(event.data));
      }
      if (event.actionType.route_path) {
        if(this.dialogRef && this.dialogRef.close){
          this.dialogRef.close();
        }
        this.baseService.redirectToOtherPage(event.actionType.route_path, event.data);
      }
    } else {
      this.putItem(event.data);
    }
  }
  
  bindGrid(params, printInfo?, callback = null) { // initial function to bind pop 
    console.log("Argss and filters are:-----------", params);
    this.loader.showSpinner();
    //implementing print
    if (printInfo) {
      if (printInfo.contentType != 'byte_array') {
        printInfo.responseType = "blob";
        var args = "reportTemplateId:grid,contentType:" + printInfo.file_type;
        if (params.args != undefined && params.args != "") {
          params.args = params.args + ',' + args;
        } else {
          params.args = args;
        }
        if (printInfo.page_size != undefined) {
          params.page_size = printInfo.page_size;
        }
      }
      params.printInfo = printInfo;
      if (this.resource.hasOwnProperty('datasource') && (this.resource.datasource.args || this.resource.datasource.filter)) {
        if (this.resource.datasource.args) {
          params.args = `${this.resource.datasource.args},${params.args}`;
          params.args = this.baseService.buildDyanamicStr(params.args, { data: this.currentData })
        }
        if (this.resource.datasource.filter) {
          params.filter = `${this.resource.datasource.filter},${params.filter}`;
          params.filter = this.baseService.buildDyanamicStr(params.filter, { data: this.currentData })
        }

      }


    }
    if (params && !printInfo) {
      this.baseService.getData(params, "", this.resource.resource, this.resource.application, this.resource.query_id).subscribe(
        (res) => {
          if (printInfo) {
            this.printService.handleFileReponse({ contentType: printInfo.file_type, key: this.baseService._currentTitle }, printInfo.action, res);
          } else {
            //if not print

            if (res.errCode != 0) {
              this.alerts.error(res.message);
              if (callback) {
                callback(false);
              }

            } else if (res.errCode == 0) {
              this.gridContainer = res;
              console.log("List of susbtitute are_______", this.gridContainer);
              if (callback) {
                callback(params);
              }
            }
          }
          this.loader.hideSpinner();
        }, (err) => {
          this.alerts.error(err.message);
          this.loader.hideSpinner();
        }
      )
    }
    if (params && printInfo) {
      this.bindGridWithPrint(params, printInfo, callback);
    }
  }
  getPrintHeading(){
    if(this['data'] && this['data'].resourcedef && this['data'].resourcedef.header){
      return this['data'].resourcedef.header
    }else{
      return this.baseService._currentTitle != undefined ? this.baseService._currentTitle : "";
    }
  }
  bindGridWithPrint(params, printInfo, callback?) { 
    let gridData = params; let action = printInfo.action? printInfo.action : "";
    let resource = printInfo.resource? printInfo.resource: this.resource.resource;
    let application = printInfo.application? printInfo.application: this.resource.application;
    let query_id = printInfo.queryId? printInfo.queryId: ( this.resource.query_id != undefined ? this.resource.query_id : "");
    
    let final_args = "";
    if (printInfo.args !== undefined && printInfo.args !== null) {
        // If printInfo.args is not undefined or null, append it with gridData.args
        if (gridData.args !== undefined && gridData.args !== null) {
            final_args = this.baseService.checkargs(gridData.args) + "," + printInfo.args;
        } else {
            final_args = printInfo.args;
        }
    } else {
        // If printInfo.args is undefined or null, just check gridData.args
        if (gridData.args !== undefined && gridData.args !== null) {
            final_args = this.baseService.checkargs(gridData.args);
        }
    }
    let obj = { queryId: query_id, args: final_args, filter: gridData.filter != undefined ? this.baseService.checkargs(gridData.filter) : false, contentType: (printInfo.contentType? printInfo.contentType: (gridData.printInfo != undefined && gridData.printInfo.file_type != undefined ? gridData.printInfo.file_type : "")), gridInfo: gridData.printInfo != undefined && gridData.printInfo.gridInfo != undefined ? btoa(JSON.stringify(gridData.printInfo.gridInfo)) : "", bannerInfo: gridData.printInfo != undefined && gridData.printInfo.bannerInfo != undefined ? btoa(JSON.stringify(gridData.printInfo.bannerInfo)) : "", bannerData: gridData.printInfo != undefined && gridData.printInfo.bannerData != undefined ? gridData.printInfo.bannerData : "", page_no: params.page_no, page_size: params.page_size, gridHeading:  this.getPrintHeading(),template: printInfo.template? printInfo.template: ""};
    let resource_ = resource != undefined && resource ? resource + "/print" : this.baseService._resourceName + "/print";
    // _resource, action, application?, resource?, bpmn_action?, responseType?)
    this.baseService.action(obj, action, application, resource_, "", { responseType: "blob" }).subscribe(
      (data: any) => {
        if (printInfo) {
          this.printService.handleFileReponse({ contentType: printInfo.file_type, key: this.baseService._currentTitle }, printInfo.action, data);
        } else {
          //if not print
          if (data.errCode == -1) {
            this.alerts.error(data.message);
            this._currentData.dataList = [];
            if (callback)
              callback(false);
          } else {
            this._currentData.dataList = data;
            if (callback)
              callback(params);
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback)
          callback(false);
      }
    );
  }

  bindDataToGrid(event) {
    this.gridData.page_no = 0;
    this.gridData.page_size = 10;
    if(this['data'] && this['data'].resourcedef && this['data'].resourcedef.list.filter){
      this.resource.filter = event;
      this.resource.search = "";
            this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData, event);
    }else{
            this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData, event);
              this.smartModalService.sendResult('success');
                //will close popup after actionn is done
                if (this.resource.refresh_on_bulk_action)
                    this.dialogRef.close({ bindGrid: true });
                else
                 this.dialogRef.close()
          }
  }
  limitChanged(event) {
    this.page_no = 0;
    this.gridData.page_no = 0;
    this.gridData.page_size = event.target.value;
    this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData);
  }
  filterChange(event) {
    this.page_no = 0;
    this.gridData.search = event;
    this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData, event);
    // this.bindGrid(this.gridData);
  }
  pageChanges(event) {
    this.page_no = event - 1;
    this.returnArgsOrFilterBasedOnReq(this.resource, this.currentData);
    // this.bindGrid(this.gridData);
  }
  sortChanges() {
    this._currentData.gridData.search = event;
    this.bindGrid(this.gridData);
  }
  valuenotFoundReturnFalse(obj: Object, key: string) { // Checking value exist or not along with the key
    if (obj.hasOwnProperty(key)) {
      return obj[key];
    } else {
      //this.alerts.error("Unable to find Substitute, Generic name not associated", key); //  Retunrning msg to UI
      return false;
    }
  }
  ngDoCheck() {
    if (!this.cdRef['destroyed']) {
      this.cdRef.detectChanges();
    }
  }
  returnArgsOrFilterBasedOnReq(datasource: any, currentobj: object, search?: string) {
    if (currentobj) {
      currentobj = currentobj;
    } else {
      currentobj = JSON.parse(sessionStorage.getItem('currentData'))
    }
    this.gridData.filter = datasource.filter ? this.baseService.buildDyanamicStr(datasource.filter, { data: currentobj }) : '';
    this.gridData.args = datasource.args ? this.baseService.buildDyanamicStr(datasource.args, { data: currentobj }) : '';
    this.gridData.page_no = this.page_no;
    this.gridData.page_size = this.gridData.page_size != undefined ? this.gridData.page_size : 10;
   // this.gridData.search = search ? search : '';
    return this.bindGrid(this.gridData); // Callling function to bind Grid
  }
  putItem(obj?: any) { //  closing popup and returning value to DynamicGrid
    this.smartModalService.sendResult(obj);
    this.dialogRef.close();
  }
  onSaveFinished($event: Event, resource: object) { // Final submit click to save data
    if (this.mainBody != null) {
      Object.keys($event['result']).forEach(key => {
        this.mainBody[key] = $event['result'][key];
      });
    } else {
      this.mainBody = {};
      Object.keys($event['result']).forEach(key => {
        this.mainBody[key] = $event['result'][key];
      });
    }
    if (resource.hasOwnProperty('popup')) {

    }
    this.baseService.action(this.mainBody, resource['action'] ? resource['action'] : 'add', resource['application'], resource['resource'], null).subscribe(res => {
      if (res.errCode == -1) {
        this.alerts.error(res.message, 'Failed');
      } else {
        this.alerts.success(res.message);
        if (resource.hasOwnProperty('popup')) {
          ///this.closePopup();
          if (resource['popup'].hasOwnProperty('redirect_path')) {
            this.redirectToPage(resource['popup'], res);
          }
          this.putItem(res);
        } else {
          this.redirectToPage(resource);
        }
      }

    }, err => {
      this.alerts.error(err.message, 'Failed');
    })
  }
  getDocumentId(value) {
    if (value == 'left') {
        if (this.index > 0) {
          this.index--;
          this.documentId = this.documentIds[this.index];
          this.pdfDocument = false;
          if (this.documentId) {
            if(this.documentId !=undefined && this.documentId !="" && this.documentId.includes("/")){
              this.baseService.getfileDataFromURL(this.documentId, "orgImage").then(res => {
                // this.imageSrc[0] = res[0].imageSrc;
                // this.fileData[0] = res[0].file;
                this.folderName = res[0].file.name;
              setTimeout(() => {
                this.getImageData(this.documentId, this.folderName);
                });
    
              }, err => {
                console.error("Error in getfileData");
              })
            }else{
            this.baseService.getfileData(this.documentId, "orgImage").then(res => {
              // this.imageSrc[0] = res[0].imageSrc;
              // this.fileData[0] = res[0].file;
              this.imageUrl = "";
              this.folderName = res[0].file.name;
              setTimeout(() => {
                this.getImageData(this.documentId, this.folderName);
              });
  
            }, err => {
              console.error("Error in getfileData");
            })
            }
          }
          // this.getImageData(this.documentId)
        }
    }
    if (value == 'right') {
        if (this.index < (this.documentIds.length - 1)) {
          this.index++;
          this.documentId = this.documentIds[this.index];
          this.pdfDocument = false;
          if (this.documentId) {
            if(this.documentId !=undefined && this.documentId !="" && this.documentId.includes("/")){
              this.baseService.getfileDataFromURL(this.documentId, this.document_type).then(res => {
                // this.imageSrc[0] = res[0].imageSrc;
                // this.fileData[0] = res[0].file;
                this.folderName = res[0].file.name;
                setTimeout(() => {
                this.getImageData(this.documentId, this.folderName);
                });
    
              }, err => {
                console.error("Error in getfileData");
              })
            }else{
            this.baseService.getfileData(this.documentId, "orgImage").then(res => {
              // this.imageSrc[0] = res[0].imageSrc;
              // this.fileData[0] = res[0].file;
              this.imageUrl = "";
              this.folderName = res[0].file.name;
              setTimeout(() => {
                this.getImageData(this.documentId, this.folderName);
              });
  
            }, err => {
              console.error("Error in getfileData");
            })
            }
          }
      }
    }
    // for (let i = 0; i < this.multiDocumentId.length; i++) {
    // }
  }
  getImageData(documentId, folderName?, itemData?: any) {
    this.imageUrl = this.baseService.getApiEndpoint("dms") + (itemData != undefined && itemData.document_type ? itemData.document_type : 'orgImage') + '/image-response-entity?args=id:' + documentId + '&application=dms';
    this.loader.showSpinner();
    this.baseService.getFileByUrl(this.imageUrl, false).subscribe((res: any) => {
      if (res) {
        this.blobResp = res;
        // this.sanitizerBlob = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(this.blobResp));
        if (this.blobResp.type == 'image/Png' || this.blobResp.type == 'image/gif' || this.blobResp.type == 'image/jpeg' || this.blobResp.type == 'image/png' || this.blobResp.type == 'image/jpg') {
          this.imageSrc[0] = this.imageUrl; 
          this.fileData[0] = { name: folderName };
        } else if (this.blobResp && this.blobResp.type == 'application/pdf') {
          this.pdfDocument = {}
          this.pdfDocument.document_name = folderName;
          this.pdfDocument.blob = this.blobResp;
        } else if (this.blobResp && this.blobResp.type == 'text/plain') {
          this.textFile.document_name = (itemData != undefined && itemData.folder_name) ? itemData.folder_name : '';

          this.baseService.getfileData(documentId, 'image-response-entity').then(data => {
            // if (data != (undefined || null || '')) {
            //   let encodedString = data[0].imageSrc.split(', ')
            //   encodedString.shift();
            //   this.decodedText = atob(encodedString);
            // }
            if (data?.[0]?.imageSrc) {
              const encodedString = data[0].imageSrc.split(', ').slice(1).join(', ');
              this.decodedText = encodedString ? atob(encodedString) : null;
            }
          })
        }
        // else if(this.blobResp && this.blobResp.type == 'application/dicom') {
        // }
        this.loader.hideSpinner();
      }
    }, (error: any) => {
      this.loader.hideSpinner();
      this.alerts.error('Error occurred')
    })
  }
  closePopup() {
    this.putItem();
  }
  redirectToPage(resource: any, res?: any) {
    if (resource.hasOwnProperty('redirect_path')) {
      let url = resource['redirect_path'];
      this.router.navigateByUrl(url);
    } else {
      this.putItem(res);
    }
  }
  //*******************EDITGRID******************** */
  listen_changes(event){
      this._currentData._editbaleGridData = event;
  }
  showAllergy(){
    let obj = {};
    if(this['data'] && this['data'].currentdata && this['data'].currentdata.length>0 && this._currentData._editbaleGridData && this._currentData._editbaleGridData.editableGrid){
      obj ={
          filter : `drugName:${this['data'].currentdata.map((f)=>{return btoa(f.displayName)}).join('!!!')},allergies:${this._currentData._editbaleGridData.editableGrid.map((r)=>{return r.getRawValue()}).map((f)=>{return f.substance}).join('!!!')}`
      }
      if(this.cimsService.iskxCimsMapping()){
        obj ={
          filter : `drugId:${this['data'].currentdata.map((f)=>{return btoa(f.guid)}).join('!!!')},allergies:${this._currentData._editbaleGridData.editableGrid.map((r)=>{return r.getRawValue()}).map((f)=>{return f.substance}).join('!!!')}`
      }
      }
      this.loader.showSpinner();
      this.baseService
  .getData(obj,"","stock","inventory-management","GET_DRUG_ALLERGY_FROM_INTEGRATION")
  .subscribe((res) => {
          if(res && res.errCode == 0){ 
              console.log("Res is",res)
              this.smartModalService.sendResult(res);
              //this.dialogRef.close();
              this.loader.hideSpinner();
          }else{
            this.loader.hideSpinner();

          }
  },(err=>{
    this.loader.hideSpinner();
  }));
  }else{
      //TODO
  }
  }
  onBulkActionClicked(event) {
    var action_obj = event;
    if (['print', 'download', 'view_file'].indexOf(action_obj.action) > -1) { //TODO: this needs to be fixed
      var menuObj = { actionType: JSON.parse(JSON.stringify(action_obj)).items, data: {} };
      if (menuObj.actionType.file_data.actionType && menuObj.actionType.file_data.actionType == 'downloadAll') {
        menuObj.actionType.file_data.page_size = 0;
      } else if (menuObj.actionType.file_data.actionType) {
        menuObj.actionType.file_data.page_size = this.gridData.page_size;
      } else {
        menuObj.actionType.file_data.page_size = this.gridData.page_size;
      }
      if (menuObj.actionType.file_data.gridInfo != undefined) {
        menuObj.actionType.file_data.gridHeading = this.baseService._currentTitle;
        var gridData = JSON.parse(JSON.stringify(this.gridData));//making a clone
        this.bindGrid(gridData, menuObj.actionType.file_data);
      } else {
        var gridData = JSON.parse(JSON.stringify(this.gridData));//making a clone
        if (gridData["filter"] != "") {
          if (menuObj.actionType.file_data.filter != undefined && menuObj.actionType.file_data.filter != "") {
            menuObj.actionType.file_data.filter = menuObj.actionType.file_data.filter + "," + gridData["filter"];
          } else {
            menuObj.actionType.file_data.filter = gridData["filter"];
          }
        }
        this.handleFile(menuObj.actionType, menuObj);
      }
    } else if (action_obj.action == 'refresh') {
      this.bindGrid(this.gridData);
    } else {
      this.loader.showSpinner();
      // setTimeout(()=>{
      this.putItem();
      this.loader.hideSpinner();
      // },1000)
    }
  }

  /********** NO CHANGE FROM THE UI ENGINE FN EXACTLY AS IT IS COPY PASTED (PLEASE REMOVE THE COMMENTED IF YOU CHANGE ANYTHING SPECIFIC) ********/
  handleFile(action, obj, callback = null) {
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';

      fileObj.resource = fileObj.resource != undefined ? fileObj.resource : this._currentData.resource;
      fileObj.application = fileObj.application != undefined ? fileObj.application : this.appService.getApplication();
      fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
      if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this._currentData.bannerJson.key.facility_id);
      } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
      }
      fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
      this.baseService.handleFile(fileObj, async (fileData) => {
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
          }
        } else {
          this.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
        this.loader.hideSpinner();
      }, (error) => {
        this.loader.hideSpinner();
        this.alerts.error('API error');
        if (callback) {
          callback(false);
        }
      });
    } else {
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }
  /********** NO CHANGE FROM THE UI ENGINE FN EXACTLY COPY PASTED (PLEASE REMOVE THE LINE IF YOU CHANGE ANYTHING SPECIFIC) ********/
}
